import type { MobileAlertMessages } from '../models'

import { LocaleEnum } from '../enums'

const MOBILE_ALERT_MESSAGES_EN: MobileAlertMessages = {
  header: 'Important message',
  title: 'Happy to see you!',
  description:
    'Unfortunately, the Playboard is not yet optimized on mobile devices. For the best experience, please use a desktop or laptop computer.' +
    '<br /><br />Thank you for your patience as we work to improve mobile compatibility.',
}

const MOBILE_ALERT_MESSAGES_ES: MobileAlertMessages = {
  header: '',
  title: '',
  description: '',
}

export const MOBILE_ALERT_MESSAGES: Record<string, { mobileAlert: MobileAlertMessages }> = {
  [LocaleEnum.ENGLISH]: {
    mobileAlert: MOBILE_ALERT_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    mobileAlert: MOBILE_ALERT_MESSAGES_ES,
  },
}
